module.exports = __webpack_public_path__ + "static/media/black-gradient.a5876862.png";